import { render, staticRenderFns } from "./MyLifeRecord.vue?vue&type=template&id=acf766b0&scoped=true"
import script from "./MyLifeRecord.vue?vue&type=script&lang=js"
export * from "./MyLifeRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf766b0",
  null
  
)

export default component.exports